import { Injectable, ErrorHandler } from "@angular/core";
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import * as Sentry from "@sentry/browser";


export const devTools = [
  StoreDevtoolsModule.instrument({
    logOnly: false,
    maxAge: 25
  })
];

export const firebaseConfig = {
  apiKey: "AIzaSyDPN4tho_L8iD1GQA2zB1vbemmt2BIYLGc",
  authDomain: "tendercuts-pos-prod.firebaseapp.com",
  databaseURL: "https://tendercuts-pos-prod.firebaseio.com",
  projectId: "tendercuts-pos-prod",
  storageBucket: "tendercuts-pos-prod.appspot.com",
  messagingSenderId: "1082427551410",
  appId: "1:1082427551410:web:0503a9c515f850e33ae3ab",
  measurementId: "G-C6RC0FC1KP"
};


// @Injectable({providedIn: "root"})
export class Constants {
  CDN = "https://cdn1.tendercuts.in";
  API_URL = "https://api.tendercuts.in/";
  ANDROID_URL = "market://details?id=com.tendercuts.app";
  IOS_URL = "itms-apps://itunes.apple.com/in/app/tendercuts-fresh-meat-fish/id1236186604";
  DEPLOY_CHANNEL = "production"
  VERSION = 30102;
  LIVE_TRACK_COLLECTION = 'order_status';
  FIRESTORE_ORDER_POSITION = 'order_track';
  PAYMENT_MODE_VERSION = 34;

  ANDROID_PROJECT_ID = "510314710553"

  CHAT = {
    ID: "fa32deb4-a670-4eaa-9485-ec40ca1daae8",
    KEY: "0afc114c-7b79-40fb-9780-8a6cd2197759"
  }

  FRESHCHAT = {
    ID: "9ad34f5a-f398-4704-af4e-94746fa44389",
    KEY: "cb87f075-045c-4aad-9cd7-7712b54525ba"
  }

  PAYMENT = [
    {
      key: "cashforpos",
      label: "Cash",
      icon: "cash",
    },
    {
      key: "ccforpos",
      label: "Card",
      icon: "card",
    },
    {
      key: "cp1forpos",
      label: "Vendor",
      icon: "person",
    },
    {
      key: "cardforpos",
      label: "Card",
      icon: "card",
    },
    {
      key: "upiforpos",
      label: "UPI",
      icon: "barcode",
    },
  ];

  CARRYBAG = { id: "879" };

  NON_SCANNABLE_ITEMS = new Set([
    456, 472, 549, 550, 551, 568, 569, 594, 595, 596, 597, 598, 599,
    600, 601, 602, 603, 604, 605, 606, 607, 629, 632
  ]);

  specialCustomers = [
    // { firstname: "Dunzo", entity_id: 220761, preferredPayment: "cp1forpos", group_id: 0 },
    { firstname: "Tendercuts cashier", entity_id: 1, group_id: 0 },
    // { firstname: "Fyndus", entity_id: 248513 , preferredPayment: "cp1forpos", group_id: 0},
  ];

  enveeSpecialCustomers = [
    { firstname: "Zomato", entity_id: 357336, preferredPayment: "cp1forpos", group_id: 0 },
    { firstname: "Swiggy", entity_id: 560605, preferredPayment: "cp1forpos", group_id: 0 }
  ]
}

export class SentryErrorHandler extends ErrorHandler {
  handleError(error) {
    
    super.handleError(error);
    
    /**
     * Bsically "Loading chunk [number] failed" 
     * error pops when browser is using cached chunks instead of 
     * newly deployed version. 
     * To handle this just need to refresh the application.
     * On refresh new chunk get loaded.
     */
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
      return;
    }

    try {
      Sentry.captureException(error.originalError || error);
    } catch (e) {
      console.error(e);
    }
  }
}


